import CONFIG from './config/config';

export const basePath = CONFIG.dev ? '/app_dev.php' : '';
export const graphQLUri = `${CONFIG.api}${basePath}/api/graphql/`;
